module.exports = __webpack_public_path__ + "img/thomas-pouclet.7572cef8.png";